import "./MGChipSingleSelect.css"

export default function MGChipSingleSelect(
    {
        label,
        isSelected,
        onClick,
        isEnable = true

    }
) {

    const classChip = isSelected ? "MGChipSingleSelect-ON" : "MGChipSingleSelect-OFF"
    return (<button className={classChip} onClick={onClick} disabled={!isEnable}>
        <span>{label}</span>
    </button>);
}